import axiosClient from '../util/request';

const loginRepo = {
  validateRecaptcha: async (token: string) => {
    const bodyFormData = new FormData();
    bodyFormData.append('token', token);

    return axiosClient.post('/v1/recaptcha/validation', bodyFormData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  createUser: async (name: string, cpf: string, birthDate: string, tenancyId: string, email: string, phone: string) => {
    const bodyFormData = new FormData();
    bodyFormData.append('name', name);
    bodyFormData.append('cpf', cpf);
    bodyFormData.append('birthDate', birthDate);
    bodyFormData.append('tenancyId', tenancyId);
    bodyFormData.append('email', email);
    bodyFormData.append('phone', phone);

    return axiosClient.post('/v1/users', bodyFormData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },


  authenticate: async (cpf: string, password: string) => {
    const bodyFormData = new FormData();
    bodyFormData.append('cpf', cpf);
    bodyFormData.append('password', password);

    return axiosClient.post('/v1/authentication', bodyFormData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
};

export default loginRepo;